import { defineComponent, useSlots, computed, createElementBlock, openBlock, normalizeClass, createCommentVNode, createElementVNode, renderSlot, createBlock } from 'vue';
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */

const _hoisted_1 = {
  key: 0,
  class: "product-list-layout__filter"
};
const _hoisted_2 = { class: "product-list-layout__content" };
const _hoisted_3 = { class: "product-list-layout__meta-bar" };
const _hoisted_4 = { class: "product-list-layout__meta-bar-info" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "product-list-layout__meta-bar-actions" };
const _hoisted_7 = {
  key: 0,
  class: "product-list-layout__filter-tags"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductListLayout",
  props: {
    showFilter: { type: Boolean, default: true },
    resultsText: { default: "" },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props) {
    const slots = useSlots();
    const showFilterTags = computed(() => {
      return !!slots.filterTags;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["product-list-layout", { "product-list-layout--no-filter": !_ctx.showFilter }])
      }, [
        _ctx.showFilter ? (openBlock(), createElementBlock("aside", _hoisted_1, [
          renderSlot(_ctx.$slots, "filter")
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          createElementVNode("div", _hoisted_3, [
            createElementVNode("div", _hoisted_4, [
              _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                class: "product-list-layout__loading-text"
              })) : (openBlock(), createElementBlock("span", {
                key: 1,
                innerHTML: _ctx.resultsText
              }, null, 8, _hoisted_5))
            ]),
            createElementVNode("div", _hoisted_6, [
              renderSlot(_ctx.$slots, "actions")
            ])
          ]),
          showFilterTags.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
            renderSlot(_ctx.$slots, "filterTags")
          ])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "list")
        ])
      ], 2);
    };
  }
});

export { _sfc_main as default };
